// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"UZNpLVA_tSCBPONsLq6S"};